export default __webpack_public_path__ + "static/media/email-forwarding.e071ff19.png";